import { render, staticRenderFns } from "./TemplateMapping.vue?vue&type=template&id=48bdab1d&scoped=true&"
import script from "./TemplateMapping.vue?vue&type=script&lang=js&"
export * from "./TemplateMapping.vue?vue&type=script&lang=js&"
import style0 from "./TemplateMapping.vue?vue&type=style&index=0&id=48bdab1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bdab1d",
  null
  
)

export default component.exports